module.exports = __webpack_public_path__ + "img/paysec_BANK_TRANSFER.f3108f47.svg";